/**
 * SEO fields and the site-search entry for the Certification & Compliance page
 * (`src/pages/why-ryerson/ryerson-commitment/certification-compliance/index.tsx`). The page copy
 * lives in the section components under
 * `src/components/WhyRyerson/RyersonCommitment/CertificationAndCompliance/`, not here.
 */
import { StaticPageContent } from "@components/Shared/model/StaticPageContent";
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { MetaContent } from "@components/Shared/model/MetaHead";

/** `MetaHead` content for the page, per language. The `fr` and `es` entries repeat the English. */
export const MetaObject: LanguageContent<MetaContent> = {
	en: {
		title: "Certification & Compliance - Ryerson",
		description:
			"Learn more about Ryerson's certifications and quality standards in metal processing.",
		url: `/why-ryerson/ryerson-commitment/certification-compliance`,
		company: true,
	},
	fr: {
		title: "Certification & Compliance - Ryerson",
		description:
			"Learn more about Ryerson's certifications and quality standards in metal processing.",
		url: `/why-ryerson/ryerson-commitment/certification-compliance`,
		company: true,
	},
	es: {
		title: "Certification & Compliance - Ryerson",
		description:
			"Learn more about Ryerson's certifications and quality standards in metal processing.",
		url: `/why-ryerson/ryerson-commitment/certification-compliance`,
		company: true,
	},
};

/**
 * The page's entry in `scripts/staticSearch.ts` (as `CertificationComplianceIndexContent`).
 * `content` is empty, so the search index gets only the `meta` fields for this page.
 */
export const PageContent: StaticPageContent = {
	meta: MetaObject,
	content: [],
};
